import { isNullCondition } from "./isNullCondition";

export function findListOfKeyConditions(conditionTree, keyConditionsList) {
  if (isNullCondition(conditionTree)) {
    return;
  }
  if (conditionTree.isKeyCondition === true) {
    keyConditionsList.push(conditionTree);
    return;
  }
  if (conditionTree.isSingleOperand() === false) {
    conditionTree.getOperands().forEach((condition) => {
      findListOfKeyConditions(condition, keyConditionsList);
    });
  }
  return;
}
